import trialContainerApi from '../../../../../api/administration/trialContainerApi';
import * as actionTypes from './actionTypes';

export function fetchTrialContainersSuccess(trialContainers) {
  return {
    type: actionTypes.FETCH_TRIAL_CONTAINERS_SUCCESS,
    trialContainers: trialContainers,
  };
}

export function fetchTrialContainersFailure(error) {
  return {
    type: actionTypes.FETCH_TRIAL_CONTAINERS_FAILURE,
    error: {
      name: error.name,
      message: error.message,
    },
  };
}

export function setTrialContainerAllIds(trialContainerIds) {
  return {
    type: actionTypes.SET_TRIAL_CONTAINER_ALL_IDS,
    trialContainerIds: trialContainerIds,
  };
}

export function setFetchRequestLoading(isLoading) {
  return {
    type: actionTypes.SET_TRIAL_CONTAINER_FETCH_REQUEST_LOADING,
    loading: isLoading,
  };
}

export function fetchTrialContainers() {
  return (dispatch, getState) => {
    const { accountId } = getState().internalReducer.internal;
    const getTrialContainers = trialContainerApi;
    dispatch(setFetchRequestLoading(true));

    return getTrialContainers(accountId)
      .then((trialContainers) => {
        const trialContainerAllIds = trialContainers.data.map((trialContainer) => trialContainer.id);

        dispatch(setTrialContainerAllIds(trialContainerAllIds));
        dispatch(fetchTrialContainersSuccess(trialContainers.data));
        dispatch(setFetchRequestLoading(false));
      })
      .catch((error) => {
        dispatch(fetchTrialContainersFailure(error));
        dispatch(setFetchRequestLoading(false));
      });
  };
}
